<maced-menubar id="Menubar" [menuList]="menuList" [closeUrl]="closeUrl" [menuLeftIconHidden]="true">
</maced-menubar>